import React from "react";
import DatosDemograficos from '../../../containers/DatosDemograficos'
import { CAMPAIGN_2025 } from '../../../constants';

const EvacuadosPorProvincia = () => {
  return <DatosDemograficos campaign={CAMPAIGN_2025} year={2025}/>
};

export default EvacuadosPorProvincia;
